import * as React from 'react';
export default function SvgShapeRotate() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.929 14.812a2 2 0 011.06-2.622l3.221-1.368a2 2 0 012.623 1.06l1.367 3.222a2 2 0 01-1.06 2.622l-3.22 1.368a2 2 0 01-2.623-1.06l-1.368-3.222zM17.127 17.25c2.83-2.831 2.83-7.545 0-10.377a7.251 7.251 0 00-9.675-.52",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.75v2.5h2.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}